import info from "./status";
import { Ppt } from "./ppt";

const w = window as any;

class muDuSdk {
  player: any = {};
  isPlay: boolean;
  needPpt = true;
  pptUrl = "";
  pptObj: any;
  streamType = "play"; //视频 类型  live直播 playBack 回看
  idx = 0;
  videoPlayBackList: any = []; //当前的视频列表
  webcastId: any = "";
  videoBg: any = "";
  type: any = "";
  hlsSite: any = "";
  currentVideoId: any = "";
  webCastProvider: any = "";
  constructor(data) {
    this.init(data);
    this.streamType = data.type;
    this.needPpt = data.needPpt;
    this.videoBg = data.videoBg;
    this.videoPlayBackList = data.videoPlayBackList;
    this.pptObj = null;
  }

  init(data) {
    if (data.type == "live") {
      this.initLiveSdk(data);
    } else {
      this.initDemandSdk(data);
    }
  }

  initLiveSdk(data) {
    const _this = this;

    w.Mudu.Init(
      // 频道id
      data.webcastId,
      () => {
        const roomLiveStatus = w.Mudu.Room.GetLiveStatus();
        info.sdk.thirdSubscribe.next({
          type: "skPlayerStatus",
          data: {
            content: { data: roomLiveStatus == 1 ? "直播" : "暂无直播" },
          },
        });
        _this.listenPlayerReady();
        _this.initThirdPartyLivePlayer(true);
        _this.listenLiveStatusChange();
        _this.listenSwitchToH5Mode();
      }
    );
  }

  initDemandSdk(data) {
    const _this = this;
    console.log("初始话 点播播放器1", w.Mudu);
    w.Mudu.Init(
      // 频道id
      data.webcastId,
      () => {
        _this.player = new w.Mudu.Player({
          containerId: "video",
          providerOrder: ["hlsjs", "html5"],
          isLive: false,
          src: data.hlsSite,
          enableErrorRetry: true, // 出错时自动retry
          image: data.videoBg,
          controls: true,
          width: "100%",
          height: "100%",
          autoplay: true,
          playbackRatesLabel: "倍速",
          playbackRates: [
            {
              label: "0.75x",
              playbackRate: 0.75,
            },
            {
              label: "1x",
              playbackRate: 1,
            },
            {
              label: "1.25x",
              playbackRate: 1.25,
            },
            {
              label: "1.5x",
              playbackRate: 1.5,
            },
            {
              label: "2x",
              playbackRate: 2,
            },
          ],
        });
        console.log("当前点播播放器实例", _this.player);
        this.initSubscribe();
        this.initThirdPartyPPT();
      }
    );
  }
  initSubscribe() {
    const _this = this;
    // 事件名，值为Player.Ready 播放器初始化完成
    w.Mudu.MsgBus.On("Player.Ready", function () {
      console.log("Mudu Player 播放器初始化完成");
      const url = '';
      console.log("Mudu Player 播放器初始化完成  后台 ppt url", url);
      if (_this.needPpt) {
        _this.pptObj = new Ppt();
      }
      if (_this.streamType == "live") {
        info.sdk.thirdSubscribe.next({
          type: "skPlayerInit",
          data: true,
        });
      } else {
        info.sdk.thirdSubscribe.next({
          type: "skPlayerStatus",
          data: {
            content: { data: "直播回放" },
          },
        });
        info.sdk.thirdSubscribe.next({
          type: "skPlayerInit",
          data: true,
        });
        const pptUrl = "";
        const pptCurrentPageIndex = w.Mudu.Room.PPT.GetCurrentPage();
        const pptTotalPage = w.Mudu.Room.PPT.GetTotalPage();
        const pptIsOpen = w.Mudu.Room.PPT.IsOpen();
        const pptIsAllowTurnPage = w.Mudu.Room.PPT.GetAllowTurnPage();

        //新加订阅消息 ppt 改变
        info.ppt.thirdSubscribe.next({
          type: "skPptInfoChange",
          data: {
            pptIsOpen: pptIsOpen, //目睹后端是否打开 显示ppt 开关 bollean
            pptUrl: pptUrl, //目睹后端当前ppt url str
            pptCurrentPageIndex: pptCurrentPageIndex, //目睹后端当前ppt 当前页码数 num
            pptTotalPage: pptTotalPage, //目睹后端当前ppt 总页码数 num
            pptIsAllowTurnPage: pptIsAllowTurnPage, //目睹后端是否允许翻页  bollean
            isHavePpt: _this.needPpt, //当前视频是否有ppt  bollean
          },
        });
      }
      info.sdk.initEnd.next(true);
    });
    //播放
    w.Mudu.MsgBus.On("Player.Play", () => {
      console.log("点播播放");
      if (!_this.isPlay) {
        _this.isPlay = true;
        info.sdk.thirdSubscribe.next({
          type: "skPlayer",
          data: true,
        });
      }
    });
    //结束
    w.Mudu.MsgBus.On("Player.Ended", () => {
      console.log("结束");
      //  播放结束看看视频是否是最后一个 不是的话 然后再去拿新的地址
      const videoList = this.videoPlayBackList;
      const index = this.idx;
      //当前视频播放结束后播放下一个视频
      if (index + 1 < videoList.length) {
        info.sdk.thirdSubscribe.next({
          type: "skSdkVideoChangeUrl",
          data: {
            href: videoList[index + 1],
            idx: index + 1,
          },
        });
      }
      //  播放结束看看视频是否是最后一个 不是的话 然后再去拿新的地址
      info.sdk.thirdSubscribe.next({
        type: "skEnded",
        data: this.isPlay,
      });
    });
    //停止播放
    w.Mudu.MsgBus.On("Player.Stoped", () => {
      console.log("停止播放");
      _this.isPlay = false;
      info.sdk.thirdSubscribe.next({
        type: "skStoped",
        data: true,
      });
    });
  }
  initThirdPartyPPT() {
    const _this = this;
    let pptUrl;
    if (_this.streamType == "live") {
      pptUrl = '';
      if (pptUrl !== "") {
        _this.needPpt = true;
      }
    } else {
      pptUrl = _this.needPpt ? "" : "";
    }
    let pptCurrentPageIndex = w.Mudu.Room.PPT.GetCurrentPage();
    let pptTotalPage = w.Mudu.Room.PPT.GetTotalPage();
    let pptIsOpen = w.Mudu.Room.PPT.IsOpen();
    let pptIsAllowTurnPage = w.Mudu.Room.PPT.GetAllowTurnPage();
    info.ppt.thirdSubscribe.next({
      type: "skPptInfoChange",
      data: {
        pptIsOpen: pptIsOpen, //目睹后端是否打开 显示ppt 开关 bollean
        pptUrl: pptUrl, //目睹后端当前ppt url str
        pptCurrentPageIndex: pptCurrentPageIndex, //目睹后端当前ppt 当前页码数 num
        pptTotalPage: pptTotalPage, //目睹后端当前ppt 总页码数 num
        pptIsAllowTurnPage: pptIsAllowTurnPage, //目睹后端是否允许翻页  bollean
        isHavePpt: _this.needPpt, //当前视频是否有ppt  bollean
      },
    });
    // 开启监听-ppt显示图片发生改变（包括后台ppt切换，后台ppt显隐切换，后台切换ppt文档）
    w.Mudu.MsgBus.On("PPT.Changed", (response) => {
      console.log("ppt显示图片发生改变");
      const { page, total_page, url } = JSON.parse(response);
      pptUrl = url || _this.pptUrl;
      pptCurrentPageIndex = page;
      pptTotalPage = total_page;
      info.ppt.thirdSubscribe.next({
        type: "skPptInfoChange",
        data: {
          pptIsOpen: pptIsOpen, //目睹后端是否打开 显示ppt 开关 bollean
          pptUrl: pptUrl, //目睹后端当前ppt url str
          pptCurrentPageIndex: pptCurrentPageIndex, //目睹后端当前ppt 当前页码数 num
          pptTotalPage: pptTotalPage, //目睹后端当前ppt 总页码数 num
          pptIsAllowTurnPage: pptIsAllowTurnPage, //目睹后端是否允许翻页  bollean
          isHavePpt: true, //当前视频是否有ppt  bollean
        },
      });
    });
    // 开启监听-ppt显隐控制发生改变
    w.Mudu.MsgBus.On("PPT.IsOpen", (response) => {
      console.log("ppt显隐控制发生改变");
      const { open } = JSON.parse(response);
      pptIsOpen = !!open;
      pptUrl = "";
      pptCurrentPageIndex = 0;
      pptTotalPage = 0;
      info.ppt.thirdSubscribe.next({
        type: "skPptInfoChange",
        data: {
          pptIsOpen: pptIsOpen, //目睹后端是否打开 显示ppt 开关 bollean
          pptUrl: pptUrl, //目睹后端当前ppt url str
          pptCurrentPageIndex: pptCurrentPageIndex, //目睹后端当前ppt 当前页码数 num
          pptTotalPage: pptTotalPage, //目睹后端当前ppt 总页码数 num
          pptIsAllowTurnPage: pptIsAllowTurnPage, //目睹后端是否允许翻页  bollean
          isHavePpt: _this.needPpt, //当前视频是否有ppt  bollean
        },
      });
    });

    // 开启监听-ppt允许前台用户自主切换控制发生改变
    w.Mudu.MsgBus.On("PPT.AllowTurnPage", (response) => {
      console.log("ppt允许前台用户自主切换控制发生改变");
      const { is_turn_page } = JSON.parse(response);
      pptIsAllowTurnPage = is_turn_page;
      //新加订阅消息 ppt 改变
      info.ppt.thirdSubscribe.next({
        type: "skPptInfoChange",
        data: {
          pptIsOpen: pptIsOpen, //目睹后端是否打开 显示ppt 开关 bollean
          pptUrl: pptUrl, //目睹后端当前ppt url str
          pptCurrentPageIndex: pptCurrentPageIndex, //目睹后端当前ppt 当前页码数 num
          pptTotalPage: pptTotalPage, //目睹后端当前ppt 总页码数 num
          pptIsAllowTurnPage: pptIsAllowTurnPage, //目睹后端是否允许翻页  bollean
          isHavePpt: _this.needPpt, //当前视频是否有ppt  bollean
        },
      });
    });

    // 开启监听-当前ppt被删除
    w.Mudu.MsgBus.On("PPT.Doc.delete", () => {
      console.log("当前ppt被删除");
      pptUrl = "";
      pptCurrentPageIndex = 0;
      pptTotalPage = 0;
      pptIsAllowTurnPage = false;
      info.ppt.thirdSubscribe.next({
        type: "skPptInfoChange",
        data: {
          pptIsOpen: pptIsOpen, //目睹后端是否打开 显示ppt 开关 bollean
          pptUrl: pptUrl, //目睹后端当前ppt url str
          pptCurrentPageIndex: pptCurrentPageIndex, //目睹后端当前ppt 当前页码数 num
          pptTotalPage: pptTotalPage, //目睹后端当前ppt 总页码数 num
          pptIsAllowTurnPage: pptIsAllowTurnPage, //目睹后端是否允许翻页  bollean
          isHavePpt: false, //当前视频是否有ppt  bollean
        },
      });
    });
    //播放器播放回看视频时, 当前视频节点上有ppt时被触发
    w.Mudu.MsgBus.On("PPT.trailer.changed", (data) => {
      console.log("当前视频节点上有ppt时被触发");
      const pptUrl = data.currentUrl;
      const pptCurrentPageIndex = w.Mudu.Room.PPT.GetCurrentPage();
      const pptTotalPage = w.Mudu.Room.PPT.GetTotalPage();
      const pptIsAllowTurnPage = w.Mudu.Room.PPT.GetAllowTurnPage();
      info.ppt.thirdSubscribe.next({
        type: "skPptInfoChange",
        data: {
          pptIsOpen: pptIsOpen, //目睹后端是否打开 显示ppt 开关 bollean
          pptUrl: pptUrl, //目睹后端当前ppt url str
          pptCurrentPageIndex: pptCurrentPageIndex, //目睹后端当前ppt 当前页码数 num
          pptTotalPage: pptTotalPage, //目睹后端当前ppt 总页码数 num
          pptIsAllowTurnPage: pptIsAllowTurnPage, //目睹后端是否允许翻页  bollean
          isHavePpt: _this.needPpt, //当前视频是否有ppt  bollean
        },
      });
    });
  }
  //  切换视频
  changeVideoUrl(data) {
    const _this = this;
    _this.idx = data.idx;
    _this.isPlay = false;
    _this.player.load([
      {
        isLive: false,
        file: data.hlsSite,
        image: data.videoBg,
      },
    ]);
    if (data.needPpt) {
      _this.needPpt = data.needPpt;
      const pptUrl = '';
      const pptCurrentPageIndex = w.Mudu.Room.PPT.GetCurrentPage();
      const pptTotalPage = w.Mudu.Room.PPT.GetTotalPage();
      const pptIsOpen = w.Mudu.Room.PPT.IsOpen();
      const pptIsAllowTurnPage = w.Mudu.Room.PPT.GetAllowTurnPage();
      //新加订阅消息 ppt 改变
      info.ppt.thirdSubscribe.next({
        type: "skPptInfoChange",
        data: {
          pptIsOpen: pptIsOpen, //目睹后端是否打开 显示ppt 开关 bollean
          pptUrl: pptUrl, //目睹后端当前ppt url str
          pptCurrentPageIndex: pptCurrentPageIndex, //目睹后端当前ppt 当前页码数 num
          pptTotalPage: pptTotalPage, //目睹后端当前ppt 总页码数 num
          pptIsAllowTurnPage: pptIsAllowTurnPage, //目睹后端是否允许翻页  bollean
          isHavePpt: _this.needPpt, //当前视频是否有ppt  bollean
        },
      });
    } else {
      _this.needPpt = data.needPpt;
      const pptIsOpen = w.Mudu.Room.PPT.IsOpen();
      info.ppt.thirdSubscribe.next({
        type: "skPptInfoChange",
        data: {
          pptIsOpen: pptIsOpen, //目睹后端是否打开 显示ppt 开关 bollean
          pptUrl: "", //目睹后端当前ppt url str
          pptCurrentPageIndex: 0, //目睹后端当前ppt 当前页码数 num
          pptTotalPage: 0, //目睹后端当前ppt 总页码数 num
          pptIsAllowTurnPage: false, //目睹后端是否允许翻页  bollean
          isHavePpt: data.isHavePpt, //当前视频是否有ppt  bollean
        },
      });
    }
  }
  createFlashTip() {
    const node = document.createElement("div");
    node.id = "live-player-flashlessTip";
    node.className = "showHls";
    node.innerHTML =
      '<a  class="clickToUseFlashLinkWrap" target="_blank"  href="http://www.adobe.com/go/getflash">' +
      '    <div class="img-bg-flashless-wrap">\n' +
      '        <div class="img-bg-flashless"></div>\n' +
      '        <div><span class="clickToUseFlashLink">点击启用Adobe Flash Player</span></div>\n' +
      "    </div>\n" +
      "</a>\n" +
      '    <div class="live-player-fix-bottom"><p><span>无法启用？</span>\n' +
      '        <span id="h5Span"   class="blue2">切换至H5播放器</span><span>（观看延时较高）进行播放</span>\n' +
      "    </p>\n" +
      "    </div>";
    return node;
  }
  listenLiveStatusChange() {
    w.Mudu.MsgBus.On(
      // 事件名，值为Room.StreamEvent
      "Room.StreamEvent",
      // 事件处理函数，参数类型为object   /推流状态改变
      (data) => {
        data = JSON.parse(data);
        info.sdk.thirdSubscribe.next({
          type: "skPlayerStatus",
          data: {
            content: { data: data.event == 1 ? "直播" : "暂无直播" },
          },
        });
        const isLive = data.event === 1;
        isLive ? this.initThirdPartyLivePlayer(true) : this.stopMuDuPlayer();
      }
    );
  }
  listenPlayerReady() {
    w.Mudu.MsgBus.On(
      // 事件名，值为Player.Ready   // 事件处理函数，参数为当前player组件对象
      "Player.Ready",
      () => {
        if (this.needPpt) {
          this.pptObj = new Ppt();
        }
        info.sdk.thirdSubscribe.next({
          type: "skPlayerInit",
          data: true,
        });
        this.initThirdPartyPPT();
      }
    );
  }
  initThirdPartyLivePlayer(forceToH5) {
    // Mudu.Room.GetLiveStatus() 获取当前的直播状态 类型为number: `1`为正在直播，`0`为不在直播
    const currentLiveStatus = !!w.Mudu.Room.GetLiveStatus();
    const hlsAddr = w.Mudu.Room.GetPlayAddr("h5");
    const defaultAddr = w.Mudu.Room.GetPlayAddr();
    const realAddr = currentLiveStatus && !forceToH5 ? defaultAddr : hlsAddr;
    this.player = new w.Mudu.Player({
      containerId: "video",
      isLive: currentLiveStatus,
      src: realAddr,
      enableErrorRetry: true, // 出错时自动retry
      image: this.videoBg, //w.Mudu.Room.GetLiveImage(),
      controls: currentLiveStatus,
      width: "100%",
      height: "100%",
      playbackRatesLabel: "倍速",
      playbackRates: [
        {
          label: "0.75x",
          playbackRate: 0.75,
        },
        {
          label: "1x",
          playbackRate: 1,
        },
        {
          label: "1.25x",
          playbackRate: 1.25,
        },
        {
          label: "1.5x",
          playbackRate: 1.5,
        },
        {
          label: "2x",
          playbackRate: 2,
        },
      ],
      provider: {
        flash: {
          renderTip: this.createFlashTip,
        },
      },
      autoplay: true,
    });
  }
  stopMuDuPlayer() {
    if (this.player) {
      this.player.setControls(false);
      this.player.stop();
    }
  }
  listenSwitchToH5Mode() {
    document.addEventListener("click", (data1) => {
      const data2 = data1 || w.Event;
      if (data2.target.id === "h5Span") {
        this.initThirdPartyLivePlayer(true);
      }
    });
  }
  changeLineStream(url) {
    this.player = new w.Mudu.Player({
      containerId: "video2",
      isLive: !!w.Mudu.Room.GetLiveStatus(),
      src: url,
      enableErrorRetry: true, // 出错时自动retry
      image: this.videoBg, //window.Mudu.Room.GetLiveImage(),
      controls: !!w.Mudu.Room.GetLiveStatus(),
      width: "100%",
      height: "563",
      provider: {
        flash: {
          renderTip: this.createFlashTip,
        },
      },
      autoplay: true,
    });
  }
  //销毁
  remove() {
    console.log("进入 销毁 播放器 remove", this.player);
    if (this.player != null) {
      console.log("mudu销毁直播播放器");
      this.player.player.remove();
    }
  }
}

export { muDuSdk };
